// KY活動画面専用ローカライズメッセージ

export const kyActivityPage = {
  ErrorMessages: {
    FOREMAN_REQ_ERR: "職長名を選択してください。",
    WORKDETAILS_REQ_ERR: "今日の作業内容を入力してください。",
    RISKYWORK_REQ_ERR: "危険作業を選択してください。",
    RISKAVOIDANCE_REQ_ERR: "危険回避策を選択してください。"
  },
  SuccessMessages: {
    KY_REGISTERED_MSG: "KY活動が正常に登録されました。",
    KY_UPDATED_MSG: "KY活動が正常に更新されました。",
    KY_DELETED_MSG: "KY活動が削除されました。"
  },
  Labels: {
    KYACTIVITY_PAGE: "危険予知活動表",
    KYACTIVITY_LIST_PAGE: "危険予知活動一覧",
    CLIENT_NAME: "契約企業名称",
    SITE_NAME: "現場名称",
    KY_DATE: "KY年月日",
    LEADER_NAME: "リーダー名",
    PARTNER_NAME: "所属会社名",
    FOREMAN_NAME: "職長名",
    PARTICIPANTS: "参加者",
    WORK_DETAILS: "今日の作業内容",
    SAFETY_INSTRUCTIONS: "安全指示事項",
    RISKY_WORK: "危険作業",
    RISK_AVOIDANCE: "危険回避策",
    TODAYS_DATE: "当日付",
    DATE: "日付",
    DANGEROUS_WORK: "危険作業",
    HAZARD_AVOIDANCE_MEASURES: "危険回避策"
  }
} as const;